export const CREDITCARD_MULTIPLIER = 1.018
export const CREDITCARD_MULTIPLIER_AMEX = 1.029
export const CREDITCARD_ISSUERS = [
  { name: 'Mastercard', id: 'mastercard', additionalServiceCharge: 1.8 },
  { name: 'American Express', id: 'amex', additionalServiceCharge: 2.9 },
  { name: 'Visa', id: 'visa', additionalServiceCharge: 1.8 },
]
